import { useContext, useState } from "react";
import Loading from "../main/Loading";
import { useGeneric } from "../useGeneric";
import AppContext from "../contexts/app-context";
import { minutesToTimeString } from "../main/WorkTimeView";
import remoteWorkImage from "../../images/icons/home.svg";
import { objectOrJSONparse } from "../functions";
import prettyDate from "../tables/functions/prettyDate";

export default function MonthlyAttendance() {
  const { employeeID }: any = useContext(AppContext);

  const [update, setUpdate] = useState(0);
  const [month, setMonth] = useState(new Date().getMonth());
  const [year, setYear] = useState(new Date().getFullYear());
  const inputValue = year + "-" + String(month + 1)?.padStart(2, "0");

  const { loading, rows }: any = useGeneric({
    name: "monthlyAttendance",
    query: {
      id: employeeID,
      month: month + 1,
      year: year,
    },
    update: update,
    delay: 1,
  });

  const data = !loading && rows && rows?.length ? rows : false;

  const { loading: sumLoading, rows: sumRows }: any = useGeneric({
    name: "monthlyAttSummary",
    query: {
      id: employeeID,
      month: month + 1,
      year: year,
    },
    update: update,
  });
  const sums = !sumLoading && sumRows && sumRows?.length ? sumRows : false;
  const monthDiff = sums && sums?.at(0)?.total_diff;

  return (
    <div>
      <form style={{ display: "grid", gridTemplateColumns: "1fr 3fr 1fr" }}>
        <button
          onClick={(e) => {
            e?.preventDefault();
            const d = new Date(year, month);
            d.setDate(0);
            setMonth(d.getMonth());
            setYear(d.getFullYear());
            setUpdate((p: number) => p + 1);
          }}
        >
          {"<"}
        </button>
        <input
          onChange={(e: any) => {
            const v = e?.target?.value;
            const y = v?.split("-")?.at(0);
            const m = Number(v?.split("-")?.at(1));
            setYear(y);
            setMonth(m);
            setUpdate((p: number) => p + 1);
          }}
          style={{
            fontSize: "14px",
            textTransform: "uppercase",
            textAlign: "center",
          }}
          type="month"
          value={inputValue}
        />
        <button
          onClick={(e) => {
            e?.preventDefault();
            const d = new Date(year, month - 1);
            d.setDate(1);
            d.setMonth(d.getMonth() + 2);
            setMonth(d.getMonth());
            setYear(d.getFullYear());
            setUpdate((p: number) => p + 1);
          }}
        >
          {">"}
        </button>
      </form>
      <div style={{ height: "70vh", maxHeight: "70vh", overflowY: "auto" }}>
        {loading ? (
          <Loading text="" little={false} />
        ) : (
          <div>
            <div style={{ fontSize: "15px", padding: "12px 6px" }}>
              Bilans miesiąca:{" "}
              <span style={{ color: monthDiff > 0 ? "green" : "brown" }}>
                {(monthDiff > 0 ? "+" : "") + minutesToTimeString(monthDiff)}
              </span>
            </div>
            <table className="universal-table big">
              <thead>
                <tr>
                  <th>Dzień</th>
                  <th>Godziny</th>
                  <th>Czas pracy</th>
                  <th>Bilans</th>
                </tr>
              </thead>

              <tbody>
                {data &&
                  data?.map((item: any) => {
                    const hours = objectOrJSONparse(item?.times);
                    const date = new Date(item?.date_start)?.toLocaleDateString(
                      "pl-PL",
                      { year: "numeric", month: "2-digit", day: "2-digit" }
                    );
                    const weekday = new Date(item?.date_start)
                      ?.toLocaleDateString("pl-PL", { weekday: "short" })
                      .toUpperCase();
                    if (item?.holiday_type && item?.work_minutes == 0) {
                      return (
                        <tr>
                          <td>
                            {date} {weekday}
                          </td>
                          <td
                            colSpan={3}
                            className={"holidayColor " + item?.holiday_class}
                          >
                            {item?.holiday_name}
                          </td>
                        </tr>
                      );
                    }
                    return (
                      <tr>
                        <td>
                          {date} {weekday}{" "}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {hours?.map((h: any) => (
                            <div>
                              {!h?.[0] && !h?.[1] ? (
                                <div style={{ fontSize: "9px" }}>
                                  {item?.holiday_name}
                                </div>
                              ) : (
                                <>
                                  {h?.t0 == 2 ? (
                                    <img
                                      src={remoteWorkImage}
                                      style={{ width: "12px" }}
                                    />
                                  ) : (
                                    <></>
                                  )}
                                  <span>
                                    {h?.["0"]} - {h?.["1"]}
                                  </span>
                                </>
                              )}
                            </div>
                          ))}
                          {item?.private_out_minutes > 0 ? (
                            <div
                              style={{
                                color: "brown",
                                fontSize: "90%",
                                padding: "1px",
                              }}
                            >
                              {" "}
                              -{minutesToTimeString(
                                item?.private_out_minutes
                              )}{" "}
                              wyjście
                            </div>
                          ) : (
                            <></>
                          )}
                        </td>
                        <td>
                          {item?.holiday_type
                            ? minutesToTimeString(item?.diff)
                            : minutesToTimeString(
                                item?.total_minutes - item?.private_out_minutes
                              )}
                        </td>
                        <td
                          style={{ color: item?.diff > 0 ? "green" : "brown" }}
                        >
                          {(item?.diff > 0 ? "+" : "") +
                            minutesToTimeString(item?.diff)}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
